export default {
    URN: 'urn',
    STARTED_AT: 'startedAt',
    WANT_TO_CHANGE_LOGIN: 'wantToChangeLogin',
    SCHOOL_CHOICE_METHOD: 'schoolChoiceMethod',
};
